import { FC, ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface LinkProps {
  href: string;
  children: ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  scroll?: boolean;
  target?: string;
  rel?: string;
}

const Link: FC<LinkProps> = ({ href, children, ...props }) => {
  // Handle hash links
  if (href.startsWith('#')) {
    return (
      <a 
        href={href} 
        {...props}
        onClick={(e) => {
          e.preventDefault();
          const element = document.querySelector(href);
          element?.scrollIntoView({ behavior: 'smooth' });
          props.onClick?.(e);
        }}
      >
        {children}
      </a>
    );
  }
  
  // Handle external links
  if (href.startsWith('http') || href.startsWith('//')) {
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }
  
  // Internal links use React Router
  return (
    <RouterLink to={href} {...props}>
      {children}
    </RouterLink>
  );
};

export default Link;